import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        提出されたストック画面[BOXを編集]より既存BOXの編集が可能です。
      </p>
    </div>
    <div>
      <p className={styles.text}>
        [BOXを編集] → 画面右上の[編集] → 設定を変更したいBOXを選択
        <br />
        下記項目を変更することができます。
      </p>
      <ul className={styles.list}>
        <li className={styles.item}>BOX名</li>
        <li className={styles.item}>適用するテンプレート</li>
        <li className={styles.item}>フォルダ</li>
        <li className={styles.item}>生徒名の公開/非公開</li>
        <li className={styles.item}>非共有BOXの切り替え</li>
        <li className={styles.item}>提出の受付/停止</li>
        <li className={styles.item}>他の先生への表示</li>
      </ul>
    </div>
    <p className={styles.text}>
      ※コメント・フィードバックは、生徒名の公開/非公開設定に関わらず生徒名・先生名が表示されます。
    </p>
  </div>
);

export const EDIT_BOX_SETTINGS_FAQ: FaqCategoryItem = {
  id: "edit-box-settings-faq",
  question: "以前作成したBOXの設定を変更したい",
  Answer,
};
